import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { SectionHead, Reveal } from "./Reveal";
import { useLang } from "../../lib/lang";
import { INFO } from "../../lib/content";

export const Faq = () => {
  const { t } = useLang();
  return (
    <section id="faq" data-testid="faq-section" className="bg-transparent px-5 py-24 lg:px-10 lg:py-36">
      <div className="mx-auto grid max-w-[1400px] grid-cols-12 gap-y-12 rounded-[32px] bg-[#FBF1E6]/85 px-5 py-14 ring-1 ring-[#A9493B]/15 backdrop-blur-md sm:px-10 lg:gap-x-16 lg:px-14">
        <div className="col-span-12 lg:col-span-4">
          <SectionHead eyebrow={t.faq.eyebrow} title={t.faq.title} titleEm="?" />
          <Reveal><a data-testid="faq-call-link" href={INFO.phoneHref} className="link-underline mt-8 inline-block font-display text-3xl text-[#721121]">{INFO.phone}</a></Reveal>
        </div>
        <Reveal className="col-span-12 lg:col-span-8">
          <Accordion type="single" collapsible defaultValue="item-0">
            {t.faq.items.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-accordion-item-${i}`} className="border-[#721121]/15">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-display text-xl text-[#1C1917] hover:no-underline hover:text-[#721121] sm:text-2xl">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-[15px] leading-relaxed text-[#57534E]">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
